import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AudioProvider } from './context/AudioContext';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import Contact from './pages/Contact';
import About from './pages/About';
import CategoryPage from './pages/CategoryPage';
import IdeasImpressions from './pages/IdeasImpressions';
import CollectionPage from './pages/CollectionPage';
import StatuesGallery from './pages/StatuesGallery';
import MixedArtGallery from './pages/MixedArtGallery';
import LightingsGallery from './pages/LightingsGallery';
import CoffeeTablesGallery from './pages/CoffeeTablesGallery';
import LightingConfigurator from './pages/LightingConfigurator';
import AdminPanel from './pages/AdminPanel';
import AdminDashboard from './pages/AdminDashboard';
import AdminArea from './pages/AdminArea';
import LoginPage from './pages/LoginPage';
import FileManagerPage from './pages/FileManagerPage';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AudioProvider>
        <CartProvider>
          <ScrollToTop />
          <AppContent />
        </CartProvider>
      </AudioProvider>
    </BrowserRouter>
  );
}

function AppContent() {
  const location = useLocation();
  const hideNavOnPaths = ['/login', '/admin/dashboard', '/admin', '/file-manager'];
  const showNav = !hideNavOnPaths.includes(location.pathname);

  return (
    <>
      {showNav && <Navigation />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sculpture" element={<StatuesGallery />} />
        <Route path="/mixed-art" element={<MixedArtGallery />} />
        <Route path="/bird-cage-lightings" element={<LightingsGallery />} />
        <Route path="/coffee-tables" element={<CoffeeTablesGallery />} />
        <Route path="/lighting-configurator" element={<LightingConfigurator />} />
        <Route path="/ideas-impressions" element={<IdeasImpressions />} />
        <Route path="/living-with-artourius" element={<IdeasImpressions />} />
        <Route path="/unique-pieces" element={<CategoryPage />} />
        <Route path="/diamond-sculptures" element={<CollectionPage />} />
        <Route path="/mixed-art-pieces" element={<CollectionPage />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin" element={<AdminArea />} />
        <Route path="/file-manager" element={<FileManagerPage />} />
      </Routes>
    </>
  );
}

export default App;